import {GET, POST} from "@/services/gateway";

const listBackups = ({pagination, sharedFolderIds, filter}) => {
  return POST('backup/list', {pagination, sharedFolderIds, filter})
}

const getBackupDetails = (id) => {
  return GET(`backup/list?id=${id}`)
}

const cancelBackup = (id) => {
  return GET(`salesforce/backup/${id}/cancel`)
}

export {
  listBackups,
  getBackupDetails,
  cancelBackup
}
